import React, { useEffect, useState } from 'react';
import * as moment from 'moment';
import ThriveStartUpEnrollment from 'apis/ThriveStartUpEnrollments/ThriveStartUpEnrollments';

const Timeline = ({ activeStep, requestId }) => {
  const [data, setData] = useState([]);
  const { getstartupLogs } = ThriveStartUpEnrollment();


  useEffect(() => {
    handleGetLogs();
  }, [])

  const handleGetLogs = async () => {
    // setLoading(true);
    try {
      let values;
      values = {
        requestId: requestId,
        type: "Unenrollment"
      };

      const res = await getstartupLogs(values);
      if (res) {
        setData(res.data);
      }
    } catch (e) {
      console.error('Get error:', e);
    } finally {
    }
  };
  const styles = {
    body: {
      margin: 0,
      fontFamily: 'Arial, sans-serif',
      background: '#f5f5f5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '80vh',
    },
    timeline: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      margin: '50px auto',
      padding: '10px',
      background: '#fff',
      borderRadius: '50px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      width: 'fit-content',
      gap: '5px',
    },
    boxBase: {
      position: 'relative',
      width: '120px',
      height: '50px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: '#fff',
      fontWeight: 'bold',
      textAlign: 'center',
      borderRadius: '8px',
      cursor: 'default',
      transition: 'background-color 0.3s ease',
    },
    info: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '200px',
      background: '#fff',
      padding: '12px 14px',
      borderRadius: '10px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      textAlign: 'left',
      fontSize: '14px',
      lineHeight: '1.4',
      boxSizing: 'border-box',
      zIndex: 10,
    },
    infoTop: {
      bottom: '150%',
      marginBottom: '10px',
    },
    infoBottom: {
      top: '150%',
      marginTop: '12px',
    },
    infoBefore: {
      content: '""',
      position: 'absolute',
      left: '50%',
      width: '2px',
      height: '30px',
      background: 'currentColor',
      transform: 'translateX(-50%)',
    },
    heading: {
      margin: '0 0 4px',
      fontSize: '16px',
      fontWeight: 600,
      color: '#333',
    },
    incompleteHeading: {
      margin: '0 0 4px',
      fontSize: '16px',
      fontWeight: 600,
      color: '#333',
      opacity: 0.5
    },
    timestamp: {
      margin: '0 0 10px',
      fontSize: '12px',
      color: '#888',
      whiteSpace: 'nowrap'
    },
    list: {
      margin: 0,
      paddingLeft: '18px',
      color: '#555',
      fontSize: '13px',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      whiteSpace: 'normal',
    },
  };

 const cancelStep = data.find(
    (i) => i.step_name === 'Cancel Unenrollment'
);

const getBoxColor = (stepId) => {

   
    if (
        cancelStep &&
        Number(stepId) > Number(cancelStep.step_id)
    ) {
        return '#CFD8DC';
    }

    // Existing logic
    if (data && data.find(i => i.step_id == `${stepId}`)) {
        return '#4CAF50';
    }

    if (stepId === activeStep) {
        return '#2196F3';
    }

    return '#CFD8DC';
};

  const hasCancelEnrollment = data.some(
  (i) => i.step_name === 'Cancel Unenrollment'
);

  return (
    <div style={styles.body}>
      <div style={styles.timeline}>
        {/* Step 1 */}
        <div
          style={{
            ...styles.boxBase,
            backgroundColor: getBoxColor(1),
            borderTopLeftRadius: '50px',
            borderBottomLeftRadius: '50px',
          }}
        >
          1
          <div style={{ ...styles.info, ...styles.infoTop, color: getBoxColor(1) }}>
            <div style={{ ...styles.infoBefore, top: '100%', backgroundColor: getBoxColor(1) }} />
            <h3 style={activeStep >= 1 ? styles.heading : styles.incompleteHeading}>Request Initiation</h3>
            {activeStep > 1 && (
              <>
                <ul style={styles.list}>
                  {
                    data && data.filter(i => i.step_id == '1').map(d => {
                      return <>
                        <li>{d.notes}</li>
                        <p style={styles.timestamp}>{moment(d.createdAt).format("ddd, Do MMM 'YY - h:mm A")}</p>
                      </>
                    })
                  }
                </ul>
              </>
            )}
          </div>
        </div>

        {/* Step 2 */}
        <div style={{ ...styles.boxBase, backgroundColor: getBoxColor(2) }}>
          2
          <div style={{ ...styles.info, ...styles.infoBottom, color: getBoxColor(2) }}>
            <div style={{ ...styles.infoBefore, bottom: '100%', backgroundColor: getBoxColor(2) }} />
            <h3 style={activeStep >= 2 ? styles.heading : styles.incompleteHeading}>Acknowledgment Notification</h3>
            {activeStep > 2 && (
              <>
                <ul style={styles.list}>
                  {
                    data && data.filter(i => i.step_id == '2').map(d => {
                      return <>
                        <li>{d.notes}</li>
                        <p style={styles.timestamp}>{moment(d.createdAt).format("ddd, Do MMM 'YY - h:mm A")}</p>
                      </>
                    })
                  }
                </ul>
              </>
            )}
          </div>
        </div>

        {hasCancelEnrollment && (
  <div style={{ ...styles.boxBase, backgroundColor: '#F44336' }}>
    3

    <div
      style={{
        ...styles.info,
        ...styles.infoTop,
        color: '#F44336'
      }}
    >
      <div
        style={{
          ...styles.infoBefore,
          top: '100%',
          backgroundColor: '#F44336'
        }}
      />

      <h3 style={styles.heading}>
        Cancel Unenrollment
      </h3>

      <ul style={styles.list}>
        {data
          .filter(i => i.step_name === 'Cancel Unenrollment')
          .map((d, idx) => (
            <React.Fragment key={idx}>
              {d.notes && <li>{d.notes}</li>}

              {d.value && (
                <li style={{ marginTop: '8px' }}>
                  Reason: {d.value}
                </li>
              )}

              <p style={styles.timestamp}>
                {moment(d.createdAt).format("ddd, Do MMM 'YY - h:mm A")}
              </p>
            </React.Fragment>
          ))}
      </ul>
    </div>
  </div>
)}

        {/* Step 3 */}
        <div style={{ ...styles.boxBase, backgroundColor: getBoxColor(3) }}>
          3
          <div
    style={{
        ...styles.info,
        ...(hasCancelEnrollment ? styles.infoBottom : styles.infoTop),
        color: getBoxColor(3)
    }}
>
    <div
        style={{
            ...styles.infoBefore,
            ...(hasCancelEnrollment
                ? { bottom: '100%' }
                : { top: '100%' }),
            backgroundColor: getBoxColor(3)
        }}
    />
            <h3 style={activeStep >= 3 ? styles.heading : styles.incompleteHeading}>Billing Closure</h3>
            {activeStep > 3 && (
              <>
                <ul style={styles.list}>
                  {
                    data && data.filter(i => i.step_id == '3').map(d => {
                      return <>
                        <li>{d.notes}</li>
                        <p style={styles.timestamp}>{moment(d.createdAt).format("ddd, Do MMM 'YY - h:mm A")}</p>
                      </>
                    })
                  }
                </ul>
              </>
            )}
          </div>
        </div>

        {/* Step 4 */}
        <div style={{
          ...styles.boxBase,
          backgroundColor: getBoxColor(4),
          borderTopRightRadius: '50px',
          borderBottomRightRadius: '50px',
        }}>
          4
          <div
    style={{
        ...styles.info,
        ...(hasCancelEnrollment ? styles.infoTop : styles.infoBottom),
        color: getBoxColor(3)
    }}
>
    <div
        style={{
            ...styles.infoBefore,
            ...(hasCancelEnrollment
                ? { top: '100%' }
                : { bottom: '100%' }),
            backgroundColor: getBoxColor(3)
        }}
    />
          {/* <div style={{ ...styles.info, ...styles.infoBottom, color: getBoxColor(4) }}>
            <div style={{ ...styles.infoBefore, bottom: '100%', backgroundColor: getBoxColor(4) }} /> */}
            <h3 style={data && data.find(i => i.step_id == '4') ? styles.heading : styles.incompleteHeading}>Add-on Plan Removal</h3>
            {data && data.find(i => i.step_id == '4') && (
              <>
                <ul style={styles.list}>
                  {
                    data && data.filter(i => i.step_id == '4').map(d => {
                      return <>
                        <li>{d.notes}</li>
                        <p style={styles.timestamp}>{moment(d.createdAt).format("ddd, Do MMM 'YY - h:mm A")}</p>
                      </>
                    })
                  }
                </ul>
              </>
            )}
          </div>
        </div>      
      </div>
    </div>
  );
};

export default Timeline;
